import { Injectable } from '@angular/core';

import { ESRI } from '../esri-loader-util';
import { IMapcoreFeatureLayer, IMapcoreMapImageLayer, IMapcoreProps, IMapcoreSubLayer } from '../types';

@Injectable({
    providedIn: 'root'
})
export class TooltipService {
    async setupMapImageLayerPopupTemplate(layer: IMapcoreMapImageLayer) {
        const fieldInfo = this.getDynamicfieldInfos(layer.mapcoreProps);
        const [PopupTemplate] = await Promise.all([ESRI.PopupTemplate]);
        const popupTemplate = new PopupTemplate({
            title: layer.sublayers.toArray()[0].title,
            content: [{
                type: 'fields',
                fieldInfos: fieldInfo
            }]
        });
        layer.sublayers.toArray().reduce<IMapcoreSubLayer[]>((prev, curr) => {
            if (curr.mapcoreProps && !prev.some(l => l.mapcoreProps && l.mapcoreProps === curr.mapcoreProps)) {
                return [...prev, curr];
            }
            return prev;
        }, []).forEach(subLayer => {
            subLayer.popupTemplate = popupTemplate;
        });
    }

    async setupFeatureLayerPopupTemplate(layer: IMapcoreFeatureLayer) {
        const fieldInfo = this.getFeatureLayerFieldInfos(layer.fields);
        const [PopupTemplate] = await Promise.all([ESRI.PopupTemplate]);
        layer.popupTemplate = new PopupTemplate({
            title: layer.title,
            content: [{
                type: 'fields',
                fieldInfos: fieldInfo
            }]
        });
    }

    setupGraphicsLayerPopupTemplate(layer) {
        if (layer.graphics.length > 0 && layer.graphics.items[0].geometry.type.toLowerCase() === 'point') {
            if (layer.graphics.items[0].attributes === null) {
                layer.graphics.items[0].attributes = {
                    latitude: layer.graphics.items[0].geometry.latitude,
                    longitude: layer.graphics.items[0].geometry.longitude
                };
            } else {
                layer.graphics.items[0].attributes.latitude = layer.graphics.items[0].geometry.latitude;
                layer.graphics.items[0].attributes.longitude = layer.graphics.items[0].geometry.longitude;
            }
            layer.graphics.items[0].popupTemplate = {
                title: layer.title,
                content: [{
                    type: 'fields',
                    fieldInfos: [{
                        fieldName: 'latitude',
                        label: 'Latitude'
                    }, {
                        fieldName: 'longitude',
                        label: 'Longitude'
                    }]
                }],
                visible: layer.visible
            };
        }
    }

    setPopupTemplateVisibility(layer) {
        switch (layer.type) {
            case 'map-image':
                if (layer.sublayers.length > 0) {
                    if (layer.sublayers.items[0].popupTemplate !== null) {
                        layer.sublayers.forEach(subLayer => {
                            if (subLayer.popupTemplate) {
                                subLayer.popupTemplate.visible = layer.visible;
                            }
                        });
                    } else {
                        this.setupMapImageLayerPopupTemplate(layer);
                    }
                }
                break;
            case 'feature':
                if (layer.popupTemplate !== null) {
                    layer.popupTemplate.visible = layer.visible;
                } else {
                    this.setupFeatureLayerPopupTemplate(layer);
                }
                break;
            case 'graphics':
                if (layer.graphics.items[0].popupTemplate !== null) {
                    layer.graphics.items[0].popupTemplate = layer.visible;
                } else {
                    this.setupGraphicsLayerPopupTemplate(layer);
                }
                break;
            default:
                break;
        }
    }

    getDynamicfieldInfos(mapcoreProps: IMapcoreProps) {
        const hoverColumns = mapcoreProps.hoverColumnList ? mapcoreProps.hoverColumnList.split(',').map((item) => item.trim()) : [];
        const fieldInfoJson = [];
        for (const hoverColumn of hoverColumns) {
            const column = mapcoreProps.columns.find(obj => obj.name === hoverColumn);
            fieldInfoJson.push({
                fieldName: hoverColumn,
                label: column ? (column.alias ? column.alias : column.name) : hoverColumn
            });
        }
        return fieldInfoJson;
    }

    getFeatureLayerFieldInfos(fields: any[] = []) {
        const fieldInfoJson = [];
        if (fields) {
            for (const field of fields) {
                fieldInfoJson.push({
                    fieldName: field.name,
                    label: field.alias
                });
            }
        }
        return fieldInfoJson;
    }
}
